import { type Offer } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { isFuture, parseISO } from "date-fns";

interface IsOfferFreshForShiftProps {
  shiftId: string;
  offer?: Offer;
}

export function isOfferFreshForShift(props: IsOfferFreshForShiftProps) {
  const { shiftId, offer } = props;

  return (
    isDefined(offer) &&
    isFuture(parseISO(offer.attributes.refreshAt)) &&
    offer.relationships?.shift.data.id === shiftId
  );
}
